import { defineNuxtPlugin, useCookie } from 'nuxt/app'
import { COOKIE_MAX_AGE_DAYS, SECONDS_PER_DAY } from '#lib/constants'
import { CookieEnum } from '#lib/enums'

export default defineNuxtPlugin(() => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const COOKIE_OPTIONS: any = {
    maxAge: SECONDS_PER_DAY * COOKIE_MAX_AGE_DAYS,
    httpOnly: false
  }

  const token = useCookie<string | null>(CookieEnum.Token, COOKIE_OPTIONS)
  const gpToken = useCookie<string | null>(CookieEnum.GPToken, COOKIE_OPTIONS)
  const layout = useCookie(CookieEnum.Layout)

  return {
    provide: {
      appCookies: {
        token,
        layout,
        gpToken,
      },
    },
  }
})
